import React from 'react';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';

import { ReactComponent as DotsVertical } from '@/assets/icons/dots-vertical.svg';
import { ReactComponent as CloseIcon } from '@/assets/icons/close-icon.svg';

import RebuyButton from '../RebuyButton/RebuyButton';
import SitOutButton from '../SitOutButton/SitOutButton';
import TableHeaderIconButtons from '../TableHeaderIconButtons/TableHeaderIconButtons';
import styles from './MobileHeaderMenu.module.css';
import { PlayerSeatDto } from '@/services/table/tableState';

interface MobileHeaderMenuProps {
  tableId: string;
  playerSeat?: PlayerSeatDto | undefined;
  onClickShowTableInfo: () => void;
  onClickShowChat: () => void;
  onClickShowLeaveTable: () => void;
  onSettingsOpen: () => void;
  onClickHandHistory: () => void;
  onOpen?: () => void;
  onClose?: () => void;
  showChat?: boolean;
}

const MobileHeaderMenu: React.FC<MobileHeaderMenuProps> = ({
  tableId,
  playerSeat,
  onClickShowTableInfo,
  onClickShowChat,
  onClickShowLeaveTable,
  onSettingsOpen,
  onClickHandHistory,
  showChat,
}) => {
  return (
    <Menu>
      <MenuButton id="menu-button" className={twMerge(styles.menuButton, 'group focus:outline-none')}>
        <CloseIcon className="hidden h-6 w-6 stroke-2 text-ph-white-30 group-data-[open]:block hover:text-ph-white" />
        <DotsVertical className="block h-6 w-6 text-ph-white-30 group-data-[open]:hidden hover:text-ph-white" />
      </MenuButton>
      <MenuItems
        id="menu-items"
        className={twMerge(
          styles.menuItems,
          'origin-top',
          'data-[closed]:scale-y-0 data-[closed]:opacity-0',
          'transition duration-200 ease-out data-[closed]:duration-150 data-[closed]:ease-in',
        )}
        anchor="bottom"
        transition
      >
        <MenuItem>
          <RebuyButton
            disabled={playerSeat?.newPlayer}
            tableId={tableId}
            seat={playerSeat?.seat}
            className="justify-stretch"
          />
        </MenuItem>
        <MenuItem>
          <SitOutButton tableId={tableId} disabled={!playerSeat?.active} />
        </MenuItem>
        <MenuItem>
          <TableHeaderIconButtons
            tableId={tableId}
            onClickShowTableInfo={onClickShowTableInfo}
            onClickShowChat={onClickShowChat}
            onClickShowLeaveTable={onClickShowLeaveTable}
            onSettingsOpen={onSettingsOpen}
            onClickHandHistory={onClickHandHistory}
            showChat={showChat}
          />
        </MenuItem>
      </MenuItems>
    </Menu>
  );
};

export default MobileHeaderMenu;
